/* src/app/modules/shared/components/render-font-so-it-loads-into-dom/render-font-so-it-loads-into-dom.component.scss */
:host {
  display: contents;
}
.font-preload {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  z-index: -10000;
}
.font-preload .preloaded-text {
  position: absolute;
  top: 0;
  left: 0;
}
/*# sourceMappingURL=render-font-so-it-loads-into-dom.component.css.map */
